module.exports = __webpack_public_path__ + "img/question-template-white-icon.4b495ebc.svg";